import UPLOAD_IMAGE from '../../../assets/images/global-banner/imageUpload.svg';
import CLAYTON_PARKING_IMAGE from '../../../assets/images/global-banner/carpark.svg';
import GEMINI_IMAGE from '../../../assets/images/global-banner/gemini.svg';
import COST_SUPPORT_IMAGE from '../../../assets/images/global-banner/costSupport.png';

// IMPORTANT:
// Banners need to be enriched with data (i.e. start/end dates, banner order) from firestore under the "config/banners" doc.
// So, when you add a new banner, you MUST add data to the firestore banner config (for each environment that you
// want the banner to appear in, i.e. dev, qa, prod).
// Banners are rendered in the order they are listed in firestore, and each banner object must have a matching "id"
// to a banner defined in this file.
//
// EXAMPLE BANNER CONFIG DOC (in firestore):
// {
//   configs: [
//     {
//       id: "exampleBanner",
//       startDate: new Date('2025-05-22T11:00:00+10:00'),
//       endDate: new Date('2025-06-20T23:59:00+10:00'),
//     },
//     {
//       id: "anotherBanner",
//       startDate: new Date('2025-05-22T11:00:00+10:00'),
//       endDate: new Date('2025-06-13T23:59:00+10:00'),
//       isNew: true, // optional: use this to set a "new" tag on the banner
//     },
//   ]
// }
//
// EXAMPLE BANNER DATA OBJECT (in this file):
// {
//   exampleBanner: {
//     title: 'Example Banner',
//     description: `This is an example banner.`,
//     backgroundColor: '#133053',
//     theme: 'dark',
//     illustration: EXAMPLE_IMAGE,
//   },
//   anotherBanner: {
//     title: 'Another Banner',
//     description: `This is another banner.`,
//     backgroundColor: '#133053',
//     theme: 'dark',
//     illustration: ANOTHER_IMAGE,
//     relevantCohorts: ["Australian", "MonashCollege"], // optional: use this to limit viewing to specific cohorts only
//   },
// }

export const GLOBAL_BANNERS = {
  claytonParking: {
    title: 'See the parking spots available at Clayton campus',
    description: '-',
    backgroundColor: '#133053',
    theme: 'dark',
    illustration: CLAYTON_PARKING_IMAGE,
    relevantCohorts: ['Australian'],
  },
  costSupport: {
    title: 'Help with everyday costs',
    description:
      'Monash is providing all students at its Australian campuses with a package of support to help with rising everyday costs',
    backgroundColor: '#133053',
    link: {
      text: 'Check what’s available and how to access them',
      url: 'https://www.monash.edu/students/cost-relief',
    },
    theme: 'dark',
    illustration: COST_SUPPORT_IMAGE,
    relevantCohorts: ['Australian', 'MonashCollege'],
  },
  gemini: {
    title: 'Introducing Google Gemini: Your new study assistant',
    description:
      'Transform how you study with Gemini’s AI tools, like Deep Research and Guided Learning. Look out for Gemini in the app launcher',
    backgroundColor: '#133053',
    theme: 'dark',
    illustration: GEMINI_IMAGE,
  },
  uploadImage: {
    title: 'Add a personal touch with custom wallpapers and backgrounds 🎨',
    description:
      'You can now upload the images you love to create a custom wallpaper for your pages and personalised backgrounds for your clock and link tiles.',
    backgroundColor: '#133053',
    theme: 'dark',
    illustration: UPLOAD_IMAGE,
  },
};
